import { createApp } from 'vue';
import App from './App.vue';
import { applyDocumentLocale } from './plugins/locale';
import { installSessionGuard } from './plugins/session';
import { createI18n } from "vue-i18n";
// Bootstrap first so `.leader-ui` tokens/utilities win on product shells (CSS isolation).
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import './assets/styles/main.scss';
import router from "../router/router.js";
import axios from 'axios';
import store from '../src/store/index.js';
import FlagIcon from 'vue-flag-icon';

function loadLocaleMessages() {
    const locales = require.context(
      "./locales",
      true,
      /[A-Za-z0-9-_,\s]+\.json$/i
    );
    const messages = {};
    locales.keys().forEach((key) => {
      const matched = key.match(/([A-Za-z0-9-_]+)\./i);
      if (matched && matched.length > 1) {
        const locale = matched[1];
        messages[locale] = locales(key);
      }
    });
    return messages;
  }
  let lang = "en";
  if (localStorage.getItem("lang")) {
    lang = localStorage.getItem("lang");
  }
  
  applyDocumentLocale(lang);
  const i18n = createI18n({
    locale: lang, // set locale
    allowComposition: true, // you need to specify that!
    fallbackLocale: lang, // set fallback locale
    messages: loadLocaleMessages(), // set locale messages
  });
  

const app = createApp(App);
app.use(FlagIcon);
app.use(i18n);
app.use(store);
app.use(router);
if (localStorage.getItem("token")) {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
}
const newLocal = lang;
axios.defaults.headers.common["Accept-Language"] = newLocal;
// axios.defaults.baseURL = 'http://127.0.0.1:8000/api';
axios.defaults.baseURL = 'https://cloudymenue.cloudy-digital.com/api';
// axios.defaults.baseURL = 'http://104.248.170.114:8080/api';
app.config.globalProperties.axios = axios;
installSessionGuard(axios, store);

// Wait for the initial route so development previews never mount the legacy API footer.
router.isReady().then(() => app.mount('#app')); 
